import * as React from 'react';

import { PublicRoutes } from '@/features/public';

export const publicRoutes = [
  {
    path: '*',
    element: <PublicRoutes />,
  },
];
